<script lang="ts" setup>
const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["close"]);

const documentEvaluativeParagraphsStore = useDocumentEvaluativeParagraphsStore(
  props.documentId
);
const { numBodyParagraphs } = storeToRefs(documentEvaluativeParagraphsStore);

const documentChecklistStore = useDocumentChecklistStore(props.documentId);
const { useChecklist } = storeToRefs(documentChecklistStore);

const expectedParagraphs = computed(() => {
  return useChecklist.value?.numParagraphs;
});
</script>

<template>
  <div>
    <p class="mb-2">
      This checklist expects
      <b class="bg-highlight-default px-1">{{ expectedParagraphs }}</b>
      paragraphs, but IEW Gradebook detected
      <b class="bg-highlight-default px">{{ numBodyParagraphs }}</b
      >.
    </p>
    <p class="mb-2">
      Because these numbers do not match, IEW Gradebook is unable to confidently
      assign items to each paragraph.
    </p>
    <p class="mb-2">
      Confirm the correct checklist is attached by looking at the top of the
      checklist.
    </p>
    <p class="mb-2">
      If the correct checklist is attached, the student either submitted an
      incorrect number of paragraphs, or the student incorrectly formatted this
      paper by pressing enter in the wrong place.
    </p>
    <p class="mb-2">
      You can still grade this paper. Select a paragraph for each item.
    </p>
    <div class="flex flex-row items-center justify-end mt-4">
      <BaseButton @click="$emit('close')" class="w-[150px]"> Ok </BaseButton>
    </div>
  </div>
</template>

<style scoped></style>
